import { DEFAULT_PRECISION_MONEY } from 'utils/constants/index'
import { divide, times } from 'number-precision'

export const formatDate = (originalDateString) => {
  const date = new Date(originalDateString)

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ]
  const day = date.getDate()
  const monthIndex = date.getMonth()
  const year = date.getFullYear()
  const formattedDate = `${day} ${months[monthIndex]} ${year}`
  return formattedDate
}

export const formatTime = (originalDateString) => {
  const date = new Date(originalDateString)

  const hours = date.getHours()
  const minutes = date.getMinutes()

  const ampm = hours >= 12 ? 'PM' : 'AM'
  const formattedHours = hours % 12 || 12 // Convert 0 to 12 for 12 AM

  const formattedTime = `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`

  return formattedTime
}

/**
 * Parses payload object from jwt
 * @param {string} token
 * @returns {Object}
 */
export const getPayloadFromToken = (token) => {
  if (token) {
    return JSON.parse(atob(token.split('.')[1]))
  }
}

export const generateClientSeed = () => {
  const availableChars = '0123456789abcdef'
  let seed = ''
  for (let i = 0; i < 32; i++) {
    seed += availableChars[Math.floor(Math.random() * availableChars.length)]
  }
  return seed
}

/**
 * Truncate toward zero to `precision` decimal places (float-safe via number-precision).
 * @param {number|string} value
 * @param {number} precision
 * @returns {number}
 */
export const getPrecision = (value, precision = DEFAULT_PRECISION_MONEY) => {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return 0
  const factor = 10 ** precision
  const result = divide(Math.trunc(times(numeric, factor)), factor)
  return result || 0
}

/**
 * Truncate toward zero to `precision` decimal places (same as getPrecision).
 * @param {number|string} amount
 * @param {number} precision
 * @returns {number}
 */
export const getPrecisionNumber = (amount, precision = DEFAULT_PRECISION_MONEY) => {
  return getPrecision(amount, precision)
}
export const getNumToStringPrecision = (input = 0, precision=DEFAULT_PRECISION_MONEY, removeTrailingZeros = true) => {
  precision = precision
  if (typeof input === 'number') {
    const factor = Math.pow(10, precision)
    input = divide(Math.trunc(times(input, factor)), factor)
    input = input.toFixed(precision)
  }

  const str = String(input)

  return str
}
/**
 *
 * @param {number} x
 * @returns {string} valid million based comma value in string
 */
export const numberWithCommas = (x) => {
  if (x === null || x === undefined || Number(x) === Number.isNaN) {
    return ''
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * Durstenfeld array shuffling algorithm
 * @param {number} array
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export const cartesianProductOfArrays = (...a) => a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())))

export function delay (ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const formatCrashMultiplier = (value) => {
  const rate = Number(value)
  if (!Number.isFinite(rate) || rate < 0) return null
  return rate.toFixed(2)
}
